import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {tap} from 'rxjs/operators';
import {TenantConfig} from '../model/tenant-config';

declare var API: string;

@Injectable({
  providedIn: 'root',
})
export class TenantConfigService {

  current!: TenantConfig;

  constructor(private http: HttpClient) {}

  /* Theme-CSS on-demand: jeder Mandant lädt nur sein eigenes Stylesheet
     (assets/css/<themeClass>.css). Im Initializer geladen und abgewartet, damit
     Angular erst nach dem Stylesheet rendert (kein FOUC). */
  load(): Promise<TenantConfig> {
    return firstValueFrom(this.http.get<TenantConfig>(API + 'anbieter/tenant-config')
      .pipe(tap(config => this.current = config)))
      .then(config => config.content.themeClass
        ? this.loadThemeCss(config.content.themeClass).then(() => config)
        : config);
  }

  private loadThemeCss(themeClass: string): Promise<void> {
    return new Promise(resolve => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `assets/css/${themeClass}.css`;
      link.onload = () => resolve();
      // Ein 404 darf den Bootstrap nicht endlos blockieren – aber laut scheitern,
      // sonst bricht das komplette Tenant-Theming (alle --tenant-*-Tokens) stumm.
      link.onerror = () => {
        console.error(`Theme-CSS ${link.href} konnte nicht geladen werden – Tenant-Theming fehlt.`);
        resolve();
      };
      document.head.appendChild(link);
    });
  }
}
